module.exports = __webpack_public_path__ + "static/media/6585-l.1102f821.png";